module.exports = __webpack_public_path__ + "img/21.0e6c1615.jpeg";